import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalTableComponent } from './table.component';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from '@gridscale/primeng17/checkbox';
import { ContextMenuModule } from '@gridscale/primeng17/contextmenu';
import { ComponentInsertorComponent } from '../component-insertor/component-insertor.component';
import { ComponentInsertorDirective } from '../component-insertor/component-insertor.directive';
import { OverlayAlertModule } from '../../overlay-alert/overlay-alert.module';
import { TooltipModule } from '../../../elements/tooltip/tooltip.module';
import { LoaderModule } from '../../loader/loader.module';
import { SharedModule } from '../../../helper/shared.module';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { A11yLinkDirective } from '../../../helper/directives/a11ylink.directive';
import { TriStateCheckboxModule } from "@gridscale/primeng17/tristatecheckbox";
import { RadioButtonComponent } from '../../../elements/radiobutton/radiobutton.component';


@NgModule({
  declarations: [
    InternalTableComponent,
    ComponentInsertorComponent,
    ComponentInsertorDirective,
  ],
  imports: [
    A11yLinkDirective,
    CommonModule,
    SharedModule,
    OverlayAlertModule,
    FormsModule,
    CheckboxModule,
    RadioButtonComponent,
    TooltipModule,
    LoaderModule,
    ContextMenuModule,
    CdkDropList,
    CdkDrag,
    TriStateCheckboxModule,
  ],
  exports: [InternalTableComponent],
})
export class InternalTableModule {}
